import { AgrAction } from './agr-action';

export class AgrBlockItem {
  public item: any;
  public borderColor?: string;
  public actions?: AgrAction[];
}
